import { render } from "./ActualitePoste.vue?vue&type=template&id=66ad8daa&scoped=true&ts=true"
import script from "./ActualitePoste.vue?vue&type=script&lang=ts"
export * from "./ActualitePoste.vue?vue&type=script&lang=ts"

import "./ActualitePoste.vue?vue&type=style&index=0&id=66ad8daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ad8daa"]])

export default __exports__